const trim = (pathname: string) => pathname.replace(/\/+$/, '') || '/'

/**
 * Whether `href` points at the page `url` is already on.
 *
 * Resolves relative hrefs against `url`, so an external link that happens to
 * share a pathname doesn't count, and ignores a trailing slash on either side.
 */
export function same_page(href: string | null | undefined, url: Pick<URL, 'href' | 'origin' | 'pathname'>) {
	if (!href) return false

	try {
		const target = new URL(href, url.href)

		return target.origin === url.origin && trim(target.pathname) === trim(url.pathname)
	} catch {
		return false
	}
}
